import { ActionReducer, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';

import { environment } from '@env/environment';
import { isDevMode } from '@angular/core';

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state: any, action: any): any {
    console.log('logger function: ');
    console.log('state', state);
    console.log('action', action);
    return reducer(state, action);
  };
}

export function handleError(): MetaReducer<any> {
  return (reducer) => (state, action) => {
    try {
      return reducer(state, action);
    } catch (err) {}
    return state;
  };
}

export function metaReducerFactory(): MetaReducer<any>[] {
  return environment.isStage || isDevMode() ? [logger, storeFreeze] : [handleError()];
}
